import { authedGet } from "./customerAuthedFetch";

export function fetchCustomerNotices(signal) {
  return authedGet("/customer/notices", signal);
}

export function overlayFingerprint(authTime, items) {
  const active = (items || [])
    .filter((n) => n.section === "active")
    .map((n) => `${n.notice_id}:${n.updated_at || ""}`)
    .sort();
  return JSON.stringify({ authTime: String(authTime || ""), notices: active });
}

export function overlayStorageKey() {
  return "customer-notices-overlay-dismissed";
}
